// NIGHTLINE EXPRESS, INC wordmark.
// Color is inherited from the parent's text color (white on dark, night-navy on light).
// The amber dash in the lower rule is the highway-centerline brand accent.
export const Logo = ({ className = "", testId = "brand-logo" }) => (
    <span data-testid={testId} className={`inline-flex flex-col items-stretch leading-none select-none ${className}`}>
        <span className="font-heading font-extrabold tracking-[0.1em] text-[1.9em] leading-[1.05] whitespace-nowrap">
            NIGHTLINE
        </span>
        <span className="mt-[0.35em] flex items-center gap-[0.6em]">
            <span className="relative h-[2px] flex-1 bg-current opacity-70">
                <span className="absolute inset-y-0 left-0 w-[38%] bg-brand opacity-100" />
            </span>
            <span className="font-heading font-semibold tracking-[0.4em] text-[0.52em] whitespace-nowrap pl-[0.4em]">
                EXPRESS, INC
            </span>
            <span className="h-[2px] flex-1 bg-current opacity-70" />
        </span>
    </span>
);

export default Logo;
